import styles from "./Button.module.css";

export default function Button({ label, variant = "primary", size = "md" }) {
  const className = [styles.button, styles[variant], styles[size]].join(" ");
  return <button className={className}>{label}</button>;
}
